import { findIndex, reverse } from 'lodash'
import { z } from 'zod'
import dayjs from 'dayjs'

const usageSchema = z
  .object({
    year: z.number(),
    month: z.number(),
    search_count: z.number(),
  })
  .transform((usage) => ({
    year: usage.year,
    month: usage.month,
    searchCount: usage.search_count,
    name: dayjs(new Date(usage.year, usage.month - 1, 10)).format('MMM YYYY'),
  }))

export const clientUsageSchema = z.object({
  usage: usageSchema.array().transform((usages) => {
    const reverseUsages = reverse(usages)
    const firstNonZeroIndex = findIndex(
      reverseUsages,
      ({ searchCount }) => searchCount > 0
    )
    const filteredArray =
      firstNonZeroIndex === -1 || firstNonZeroIndex >= 7
        ? usages.slice(-4)
        : usages.slice(firstNonZeroIndex)
    return filteredArray
  }),
  cap: z.number().nonnegative(),
  expiry: z.string().nullable(),
})
